module.exports = __webpack_public_path__ + "media/images/innovation-photo-2dd90297424e5b2c870f5318800d3113.jpg";